/**
 * Main Entry Point
 * Initializes the React application with i18n support
 */

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './i18n/config' // Initialize i18next
import App from './app.tsx'
import { RootBoundary } from './components/common/crash-sheet'

// Development only: warn when a screen shows more than one gold decisive
// action. Imported inside the DEV branch, so production never loads it.
if (import.meta.env.DEV) {
  void import('./utils/decisive-action-watch').then((m) => m.watchDecisiveActions())
}

// Whatever fails to draw, on the way in or in the game, leaves the crash
// sheet on the ground rather than an empty page.
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RootBoundary>
      <App />
    </RootBoundary>
  </StrictMode>,
)
